import { DolozkaVplyvovFormData } from '../../../../model/sprievodnyDokument/DolozkaVplyvovFormData';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import getFormData from '../../../../function/getFormData';
import { FormDataResponse } from '../../../../model/sprievodnyDokument/FormDataResponse';

interface ReturnType {
  formDataResponse: FormDataResponse<DolozkaVplyvovFormData>,
  formDataStatus: ClientStatus,
}

const map = (dolozkaVplyvov: DolozkaVplyvovFormData): DolozkaVplyvovFormData => ({
  ...dolozkaVplyvov,
  terminZaciatkuPpk: dolozkaVplyvov?.terminZaciatkuPpk ? new Date(dolozkaVplyvov.terminZaciatkuPpk) : null,
  terminUkonceniaPpk: dolozkaVplyvov?.terminUkonceniaPpk ? new Date(dolozkaVplyvov.terminUkonceniaPpk) : null,
});

export default (
  type: string,
  year: number,
  index: number,
  stadiumUuid: string,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    getFormData,
    [type, year, index, 'DolozkaVplyvov', stadiumUuid],
    [],
  );
  return {
    formDataResponse: data ? {
      formData: map(data.formData as DolozkaVplyvovFormData),
      materialDetail: data.materialDetail,
    } : null,
    formDataStatus: status,
  };
};
